import api from '../api'

const baseUrl = '/BizSchool/api/Admin'

const dadbanCourseProvider = {
  getAllCourses(params = {}) {
    return api.post(`${baseUrl}/CourseTable`, {
      params,
    })
  },

  getCourse(id) {
    return api.get(`${baseUrl}/GetCourse/${id}`)
  },

  getAllCourseUsers(params = {}) {
    return api.post(`${baseUrl}/PeopleTable`, {
      params,
    })
  },

  getInputs() {
    return api.get(`${baseUrl}/CourseInput`)
  },

  addCourse(params) {
    return api.post(`${baseUrl}/Course`, params)
  },

  updateCourse(params = {}) {
    return api.put(`${baseUrl}/Course`, params)
  },

  deleteCourse(params) {
    return api.delete(`${baseUrl}/Course/${params}`)
  },

  addCoursePrerequisite(params) {
    return api.post(`${baseUrl}/CoursePrerequisite`, params)
  },

  searchCoursePrerequisite(params) {
    return api.post(`${baseUrl}/SearchCoursePrerequisite`, params)
  },

  deleteCoursePrerequisite(params = {}) {
    return api.delete(`${baseUrl}/CoursePrerequisite`, { params })
  },

  updateUserRole(params = {}) {
    return api.put(`${baseUrl}/ProductPeopleRole`, params)
  },
  updateCourseHeadlineOrder(params) {
    return api.put(`${baseUrl}/CourseSessionOrder`, params)
  },

  getAdminClassList(params) {
    return api.get(`${baseUrl}/AdminProductPeople/id?id=${params}`)
  },

  generateLoginUrl(params = {}) {
    return api.post(`/BizSchool/api/Home/LoginUrl`, params)
  },

  getTrainUsers(params) {
    return api.get(`${baseUrl}/PracticePeopleTable/id?id=${params}`)
  },

  updateUserTrainScore(params = {}) {
    return api.put(`${baseUrl}/PracticePeopleScore/id`, params)
  },
}

export default dadbanCourseProvider
